// Generated by scripts/generate-public-surface.ts. Do not edit.

import type {
  CountryValidator,
  ParsedPersonId,
} from "../../types";

import { createValidator } from "#stdnum-runtime";

const rc: CountryValidator<"CZ", ParsedPersonId> =
  createValidator("cz.rc", 50);

export default rc;
export const compact = rc.compact;
export const format = rc.format;
export const validate = rc.validate;
export const generate = (): string =>
  rc.generate?.() ??
  (() => {
    throw new Error(
      "Validator cz.rc cannot generate values",
    );
  })();
export const parse = rc.parse;
